import type { Accept } from 'react-dropzone'

import { formatMegabytesToBytes } from '../../../utils/formatMegabytesToBytes'

/**
 * STR-223 — product policy for the imported (shoebox) upload surface, not a mirror
 * of a backend limit: the same `uploadFile` endpoint is driven at 20 MB elsewhere.
 *
 * The MB figure is the single source for both the `maxSize` prop and the
 * `{{maxSizeMb}}` the oversize toast interpolates.
 */
export const IMPORTED_INVOICE_MAX_SIZE_MB = 10

export const IMPORTED_INVOICE_MAX_SIZE_IN_BYTES = formatMegabytesToBytes(IMPORTED_INVOICE_MAX_SIZE_MB)

export const IMPORTED_INVOICE_ACCEPTED_FORMATS: Accept = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpeg', '.jpg'],
  'image/png': ['.png'],
}
